module.exports = __webpack_public_path__ + "img/T1_ty_11.b2963586.png";